var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'd-flex primary--text text-uppercase font-weight-black',
    _vm.className,
    !_vm.small ? 'text-h5  text-md-h4' : 'text-h6 text-md-h5' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }